import { Injectable } from '@angular/core';
import { MessengerService as MtLibsMessengerService } from '@mira-avant/mtlibs';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AudioService } from './audio.service';

@Injectable({
	providedIn: 'root',
})
export class MessengerService {
	public message$: BehaviorSubject<string> = new BehaviorSubject('');
	private messenger: MtLibsMessengerService | undefined;
	public loading: boolean = false;
	private sub: Subscription | undefined;

	constructor(private audioService: AudioService) {
		// window.addEventListener("message", (event) => {
		// 	//console.log('Angular received message:', event);
		// 	this.message$.next(event.data);
		// }, false);
	}

	/**
	 * Set up the messenger - only one allowed at a time. You must destroy
	 * the current listener to initialize a new one.
	 * @date 5/23/2023 - 8:54:06 AM
	 *
	 * @public
	 * @param {*} win
	 */
	public init(win: any): void {
		if (this.messenger) {
			this.messenger.destroy();
		}

		this.messenger = new MtLibsMessengerService(win);
	}

	/**
	 * Send a message to the window.
	 * @date 5/23/2023 - 8:54:26 AM
	 *
	 * @public
	 * @param {string} channel
	 * @param {*} message
	 */
	public sendMessage(channel: string, message: any) {
		if (!this.messenger) {
			throw new Error('Messenger not initialized');
		}

		// console.log('angular is sending postrobot message', message);

		this.messenger.sendMessage(channel, message);
	}

	/**
	 * Destroy the messenger.
	 * @date 5/23/2023 - 8:54:31 AM
	 *
	 * @public
	 */
	public destroy(): void {
		this.message$.next('');

		if (!this.messenger) {
			throw new Error('Messenger not initialized');
		}

		this.messenger.destroy();

		this.messenger = undefined;
	}
}
